// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Changed API Router name to Camel Case
// MODIFIED DATE: 18-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET CLOSE LOAN START *********************** */
export const closeLoanMemberListGet = (listData: any) => {
	const data = {
		GetGroupMemberDetailsForCloseDetailsToken: listData,
	};
	const url = `${API_URL}getGroupMemberDetailsForClose`;
	return makeApiCall(url, data);
};
/** ***************** GET CLOSE LOAN END *********************** */

/** ***************** UPDATE CLOSE LOAN START *********************** */
export const closeLoanMemberListUpdate = (listData: any) => {
	const data = {
		UpdateGroupMemberDetailsForCloseToken: listData,
	};
	const url = `${API_URL}updateGroupMemberDetailsForClose`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE CLOSE LOAN END *********************** */

/** ***************** REVERT CLOSE LOAN START *********************** */
export const closeLoanMemberListRevert = (listData: any) => {
	const data = {
		RevertGroupMemberDetailsForCloseToken: listData,
	};
	const url = `${API_URL}revertGroupMemberDetailsForClose`;
	return makeApiCall(url, data);
};
/** ***************** REVERT CLOSE LOAN END *********************** */
